<template>
  <!-- Annotation Confirm Modal State -->
  <a-modal
    id="annotation-confirm-modal"
    v-model:visible="showAnnotationConfirmModal"
    title="Confirmation"
    :ok-button-props="{ id: 'annotation-confirm-modal-ok-btn' }"
    :cancel-button-props="{
      id: 'annotation-confirm-modal-cancel-btn',
      style: { marginLeft: 'auto' },
    }"
    destroy-on-close
  >
    <template #closeIcon>
      <close-outlined id="annotation-confirm-close-btn" />
    </template>
    <p>
      Are you sure you want to exit labeling? Please select one of the options
      below.
    </p>
    <template #footer>
      <div class="d-flex w-100">
        <span class="ml-auto" />
        <a-button id="close-annotation-btn" @click="handleAnnotationClose">
          Continue without saving
        </a-button>
        <a-button
          id="save-annotation-progress-btn"
          type="primary"
          @click="emitter.emit('save-label')"
        >
          Save progress
        </a-button>
      </div>
    </template>
  </a-modal>

  <!-- Annotation Modal -->
  <a-modal
    id="annotation-modal"
    :visible="showAnnotationModal"
    :title="null"
    width="100%"
    wrap-class-name="full-modal"
    :body-style="{
      padding: '1em',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
    }"
    destroy-on-close
  >
    <a-spin v-if="loading" class="m-auto" size="large" />
    <annotation-component
      ref="annotationComponent"
      :key="selectedVideo"
      :loading="loading"
      :video="selectedVideo"
      :task-id="task_id"
      :prev-meta-data="prevMetaData"
      :organization="organization"
      :update-task-record="updateTaskRecord"
      @updateLoading="(val) => (loading = val)"
      @stopLoading="loading = false"
      @onSave="handleLabelling"
      @closeModal="showAnnotationConfirm"
    />
    <template #closeIcon>
      <div class="mr-4">
        <close-circle-outlined
          id="annotation-cross-btn"
          @click="showAnnotationConfirm"
        />
      </div>
    </template>
    <template #footer>
      <div class="d-flex w-100">
        <a-button
          id="test-btn"
          @click="handleAnnotateLabellingNavigate()"
          style="margin-right: auto"
        >
          Labelling Page
        </a-button>
        <span class="ml-auto" />
        <a-button
          v-if="!loading"
          id="cancel-annotation-btn"
          :disabled="isSavingAnnoation"
          @click="showAnnotationConfirm"
        >
          Cancel
        </a-button>
        <a-button
          v-if="!loading"
          id="save-annotation-btn"
          style="margin-right: 6em"
          :disabled="!isSubstepsChanged"
          type="primary"
          :loading="isSavingAnnoation"
          @click="emitter.emit('save-label')"
        >
          Save
        </a-button>
      </div>
    </template>
  </a-modal>
  <!-- Annotation Modal Labelling -->
  <a-modal
    id="annotation-modal"
    :visible="showAnnotationLabellingModal"
    :title="null"
    width="100%"
    wrap-class-name="full-modal"
    :body-style="{
      padding: '1em',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
    }"
    @cancel="showAnnotationLabelConfirm"
    destroy-on-close
  >
    <a-spin v-if="loading" class="m-auto" size="large" />
    <annotation-component-labelling
      ref="annotationComponentLabelling"
      :key="selectedVideo"
      :loading="loading"
      :video="selectedVideo"
      :task-id="task_id"
      :prev-meta-data="prevMetaData"
      :organization="organization"
      :update-task-record="updateTaskRecord"
      @updateLoading="(val) => (loading = val)"
      @stopLoading="loading = false"
      @closeModal="showAnnotationLabelConfirm"
    />
    <!-- <template #closeIcon>
      <close-circle-outlined
        id="annotation-cross-btn"
        @click="showAnnotationLabelConfirm"
      />
    </template> -->
    <template #footer>
      <div class="d-flex w-100">
        <a-button
          id="test-btn"
          @click="handleAnnotateNavigate()"
          style="margin-right: auto; border-radius: 4px"
        >
          Annotation Page
        </a-button>
      </div>
    </template>
  </a-modal>
  <!-- Merge Videos Modal -->
  <a-modal
    id="merge-videos-modal"
    :visible="showMergeVideosModal"
    :title="null"
    width="100%"
    wrap-class-name="full-modal"
    :body-style="{
      padding: '1em',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
    }"
    @cancel="handleMergeVideosCloseLabel"
    destroy-on-close
  >
    <a-spin v-if="loading" class="m-auto" size="large" />
    <merge-videos-component
      ref="MergeVideosComponent"
      :key="videosInfo"
      :loading="loading"
      :videos="videosInfo"
      :task-id="task_id"
      :prev-meta-data="prevMetaData"
      :organization="organization"
      @updateLoading="(val) => (loading = val)"
      @stopLoading="loading = false"
      @closeModal="handleMergeVideosCloseLabel"
    />
    <template #footer>
      <!-- <div class="d-flex w-100">
        <a-button
          id="test-btn"
          @click="handleAnnotateNavigate()"
          style="margin-right: auto; border-radius: 4px"
        >
          Annotation Page
        </a-button>
      </div> -->
    </template>
  </a-modal>

  <!-- Trimming Modal -->
  <a-modal
    id="timming-modal"
    v-model:visible="showTrimModal"
    :title="null"
    width="100%"
    wrap-class-name="full-modal"
    :body-style="{
      padding: '1em',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
    }"
    destroy-on-close
    @cancel="handleTrimModalClose"
  >
    <template #closeIcon>
      <close-outlined id="trimming-modal-close-btn" />
    </template>
    <a-spin v-if="loading" class="m-auto" size="large" />
    <trimming-component
      ref="trimming"
      :key="videoToTrim"
      :loading="loading"
      :video="videoToTrim"
      :task-id="task_id"
      :task-name="taskName"
      @stopLoading="loading = false"
      @updateTrimProgress="(progress) => (trimProgress = progress)"
      @updateTrimLoading="(isLoading) => (isTrimming = isLoading)"
      @closeModal="finishTrimming"
    />

    <template #footer>
      <a-row class="w-100 d-flex align-items-center">
        <a-col span="2" class="ml-auto mr-4">
          <a-button
            v-if="!loading"
            id="trim-video-btn"
            type="primary"
            :loading="isTrimming"
            @click="emitter.emit('trim-video')"
          >
            Trim Video
          </a-button>
        </a-col>
      </a-row>
    </template>
  </a-modal>

  <!--  Video Modal V2 -->
  <a-modal
    id="video-modal"
    v-model:visible="showVideoModal"
    centered
    :title="videoToPlay?.fileName"
    :footer="null"
    width="70vw"
    :body-style="{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
    }"
    @cancel="handleVideoModalClose"
  >
    <template #closeIcon>
      <close-outlined id="video-modal-close-btn" />
    </template>

    <div class="d-flex justify-content-center align-items-center mb-3">
      <div class="d-flex justify-content-center align-items-center">
        <div
          @click="!isPreviousDisabled && handlePlayPrevious(videoToPlay)"
          class="mx-2 cursor-pointer"
          :style="{
            color: isPreviousDisabled ? 'gray' : '#1890ff',
            fontSize: '20px',
            marginTop: '0',
            marginBottom: '0',
          }"
        >
          <ArrowLeftOutlined />
        </div>
        <div
          @click="!isNextDisabled && handlePlayNext(videoToPlay)"
          class="mx-2 cursor-pointer"
          :style="{
            color: isNextDisabled ? 'gray' : '#1890ff',
            fontSize: '20px',
            marginTop: '0',
            marginBottom: '0',
          }"
        >
          <ArrowRightOutlined />
        </div>
      </div>
    </div>

    <div
      v-if="isfetchingVideoUrl"
      class="w-100 d-flex"
      style="height: 350px !important"
    >
      <a-spin class="m-auto" size="large" />
    </div>

    <video
      v-else
      ref="videoPlayer"
      id="video-to-play-elem"
      class="w-100 mv-3 rounded"
      controls
      :src="videoToPlay?.fileURL"
      style="
        max-height: 45vh;
        width: auto;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        margin-bottom: 1em;
      "
      @timeupdate="handleVideoTimeUpdate"
    />

    <a-tabs v-model:activeKey="videoModalActiveTab" class="flex-grow-1">
      <a-tab-pane key="details" tab="Video Details">
        <a-descriptions title="Video Information" class="text-start">
          <a-descriptions-item id="video-filename-tag" label="Name" span="3">
            <a-tag color="blue">{{ videoToPlay?.fileName }}</a-tag>
          </a-descriptions-item>
          <a-descriptions-item id="video-resolution-tag" label="Resolution">
            <a-tag color="blue">{{ videoToPlay?.resolution }}</a-tag>
          </a-descriptions-item>
          <a-descriptions-item
            id="video-duration-tag"
            label="Duration"
            span="2"
          >
            <a-tag color="blue">{{ videoToPlay?.duration }}</a-tag>
          </a-descriptions-item>
          <a-descriptions-item id="video-fps-tag" label="FPS">
            <a-tag color="blue">{{ videoToPlay?.fps }}</a-tag>
          </a-descriptions-item>
          <a-descriptions-item id="video-labelled-tag" label="Labelled">
            <a-tag color="blue">{{ videoToPlay?.labelled.toFixed(1) }}%</a-tag>
          </a-descriptions-item>
        </a-descriptions>
      </a-tab-pane>

      <a-tab-pane key="tags" tab="Tags">
        <div class="video-tags-container">
          <a-row :gutter="16" class="tags-main-row">
            <!-- Left Column - Add Tag Controls -->
            <a-col :xs="24" :sm="24" :md="12" :lg="12" class="tags-add-column">
              <div class="tags-controls-container">
                <div
                  class="d-flex justify-content-between align-items-center mb-3"
                >
                  <h5 class="mb-0">Add Timestamp Tag</h5>
                  <div class="d-flex align-items-center">
                    <span class="mr-2">{{
                      isModelTag ? 'Model Tag' : 'Video Tag'
                    }}</span>
                    <a-switch
                      v-model:checked="isModelTag"
                      @change="handleTagSwitchChange"
                    />
                  </div>
                </div>

                <!-- Tag selection -->
                <div class="mb-1">
                  <label class="form-label">Select Tag:</label>
                  <a-select
                    v-model:value="newTagValue"
                    :placeholder="
                      isModelTag ? 'Select Model Tag' : 'Select Video Tag'
                    "
                    class="w-100"
                    :options="getFilteredTagOptions"
                    :loading="loadingTags"
                    show-search
                    :filter-option="filterOption"
                    @search="onTagSearch"
                    @change="onTagChange"
                    allow-clear
                  >
                    <a-select-option
                      v-if="newlyCreatedTag"
                      :key="'new-tag-option'"
                      :value="newlyCreatedTag"
                    >
                      {{ newlyCreatedTag }}
                    </a-select-option>
                  </a-select>
                </div>

                <!-- Step selection for Model Tags -->
                <div v-if="isModelTag" class="mb-1">
                  <label class="form-label">Select Step (Optional):</label>
                  <a-select
                    v-model:value="selectedStep"
                    placeholder="Select Step"
                    mode="multiple"
                    class="w-100"
                    :options="stepOptions"
                    :filter-option="filterOption"
                    allow-clear
                  >
                    <template #maxTagPlaceholder="omittedValues">
                      <span style="color: #1890ff"
                        >+{{ omittedValues.length }} more</span
                      >
                    </template>
                  </a-select>
                </div>

                <!-- Add Tag Button -->
                <div class="mb-1">
                  <a-button
                    type="primary"
                    block
                    size="large"
                    @click="addTimestampTag"
                    :disabled="!newTagValue && !selectedStep.length"
                    :loading="addingTimestampTag"
                  >
                    Add Tag
                  </a-button>
                </div>
              </div>
            </a-col>

            <!-- Right Column - Tags List -->
            <a-col :xs="24" :sm="24" :md="12" :lg="12" class="tags-list-column">
              <div class="tags-list-container">
                <div
                  class="d-flex justify-content-between align-items-center mb-3"
                >
                  <h5 class="mb-0">
                    Existing Tags ({{ videoTimestampTags.length }})
                  </h5>
                </div>

                <div v-if="loadingVideoTags" class="text-center py-4">
                  <a-spin size="large" />
                  <p class="mt-2 text-muted">Loading tags...</p>
                </div>
                <div
                  v-else-if="videoTimestampTags.length === 0"
                  class="text-center text-muted py-4"
                >
                  <p><strong>No tags added yet</strong></p>
                  <small
                    >Start playing the video and add tags at specific
                    moments</small
                  >
                </div>
                <div v-else class="tags-scrollable-container">
                  <a-list
                    :data-source="videoTimestampTags"
                    item-layout="horizontal"
                    size="small"
                    class="tags-list-scrollable"
                  >
                    <template #renderItem="{ item, index }">
                      <a-list-item
                        class="timestamp-tag-item clickable-tag"
                        @click="
                          seekToTimestamp(parseTimeToSeconds(item.time_stamp))
                        "
                        style="cursor: pointer"
                        :title="
                          'Click to seek to ' + convertToMmSs(item.time_stamp)
                        "
                      >
                        <template #actions>
                          <a-tooltip title="Jump to timestamp">
                            <a-button
                              type="link"
                              size="small"
                              @click.stop="
                                seekToTimestamp(
                                  parseTimeToSeconds(item.time_stamp)
                                )
                              "
                            >
                              <template #icon>
                                <PlayCircleOutlined />
                              </template>
                            </a-button>
                          </a-tooltip>
                          <a-popconfirm
                            title="Are you sure you want to remove this tag?"
                            ok-text="Yes"
                            cancel-text="No"
                            @confirm="deleteTimestampTag(item.id)"
                          >
                            <a-tooltip title="Delete tag">
                              <a-button
                                type="link"
                                size="small"
                                danger
                                :loading="deletingTagId === item.id"
                                @click.stop
                              >
                                <template #icon>
                                  <DeleteOutlined />
                                </template>
                              </a-button>
                            </a-tooltip>
                          </a-popconfirm>
                        </template>
                        <a-list-item-meta>
                          <template #title>
                            <div class="d-flex align-items-center">
                              <a-tag color="blue" class="timestamp-tag">
                                {{ convertToMmSs(item.time_stamp) }}
                              </a-tag>
                              <a-tag
                                :color="
                                  getTagType(item.tag) === 'model'
                                    ? 'purple'
                                    : 'green'
                                "
                                class="tag-name"
                              >
                                {{ item.tag.name }}
                              </a-tag>

                              <a-tag
                                v-if="item.step_name"
                                color="purple"
                                class="tag-name"
                              >
                                {{ item.step_name }}
                              </a-tag>
                            </div>
                          </template>
                          <template #description>
                            <small class="text-muted">
                              Added {{ formatRelativeTime(item.created_at) }}
                              <span v-if="item.added_by">
                                by User #{{ item.added_by }}</span
                              >
                            </small>
                          </template>
                        </a-list-item-meta>
                      </a-list-item>
                    </template>
                  </a-list>
                </div>
              </div>
            </a-col>
          </a-row>
        </div>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
  <!-- Comments Modal -->
  <a-modal
    id="comments-modal"
    v-model:visible="commentsModal"
    title="Comments"
    :footer="null"
    centered
  >
    <template #closeIcon>
      <close-outlined id="comments-modal-close-btn" />
    </template>
    <Comments :comments="comments" :selected-video="selectedVideo" />
    <!-- <a-list
      id="comments-list"
      :data-source="comments"
      item-layout="horizontal"
      style="height: 40vh; overflow: auto"
      size="small"
    >
      <template #renderItem="{ item, index: commentIndex }">
        <a-list-item :id="'comment-' + commentIndex">
          <a-comment :author="item.user_id.username" :content="item.comment">
            <template v-if="isAssociateUserComment(item.user_id)" #actions>
              <delete-outlined
                :id="'delete-comment-btn-' + commentIndex"
                class="text-danger"
                @click="deleteComment(item)"
              />
            </template>
          </a-comment>
        </a-list-item>
      </template>
    </a-list>
    <a-comment>
      <template #content>
        <a-form-item>
          <a-textarea
            id="label-new-comment-input"
            v-model:value="newComment"
            :rows="4"
          />
        </a-form-item>
        <a-form-item>
          <a-button
            id="add-comment-btn"
            html-type="submit"
            :loading="addingComment"
            type="primary"
            @click="handleAddComment"
          >
            Add Comment
          </a-button>
        </a-form-item>
      </template>
    </a-comment> -->
  </a-modal>

  <!-- Tags Modals -->
  <a-modal
    id="tags-modal"
    v-model:visible="tagsModal"
    title="Tags"
    :footer="null"
    centered
  >
    <template #closeIcon>
      <close-outlined id="tags-modal-close-btn" />
    </template>
    <div style="height: 30vh">
      <a-select
        v-model:value="currentSelectedTag"
        id="select-tag-input"
        show-search
        mode="multiple"
        placeholder="Select Tag"
        :disabled="loadingTags"
        :loading="loadingTags"
        :options="tagOptions"
        :filter-option="filterOption"
        class="w-100"
        dropdown-class-name="select-tag-input-class"
        @select="handleAddTag"
        @deselect="handleTagRemove"
      />
    </div>
  </a-modal>

  <a-row :gutter="[16, 16]" class="py-4 px-2 p-md-4">
    <a-col :xs="20" :sm="22" :md="8" :lg="8">
      <a-select
        id="label-data-select-task"
        ref="label_task_select"
        v-model:value="task_id"
        class="w-100"
        show-search
        placeholder="Select Operation"
        :options="taskOptions"
        :filter-option="filterOption"
        :loading="isFetchingTasks"
        @change="() => $refs.label_task_select.blur()"
      />
    </a-col>
    <a-col :xs="24" :sm="22" :md="8" :lg="8">
      <a-select
        id="analytics-trace-select-steps-filter"
        v-model:value="selectedTags"
        mode="multiple"
        class="w-100"
        placeholder="Select Tags"
        :filter-option="filterOption"
        :options="organizationTagOptions"
        :get-popup-container="getPopupContainer"
        :max-tag-count="2"
        @change="handleTagSelect"
      />
    </a-col>
    <a-col :span="4">
      <!-- <a-col v-if="showDurationInput" :span="8"> -->
      <a-button block @click="handleSelectAllTags">
        {{ isAllTagsSelected ? 'Unselect all' : 'Select all' }}
      </a-button>
      <!-- </a-col> -->
    </a-col>
    <!-- <a-col
      :xs="24"
      :sm="24"
      :md="24"
      :lg="13"
      :xl="11"
      class="d-md-flex d-sm-none d-none ml-auto"
    >
      <a-space class="ml-auto">
        <a-button id="add-tags-button" type="primary" @click="openTagsModal">
          <template #icon>
            <plus-outlined />
          </template>
          Add Tags
        </a-button>
      </a-space>
    </a-col> -->
    <!-- mobile screen -->
    <a-col :xs="4" :sm="2" class="d-block d-sm-block d-md-none">
      <div class="demo-dropdown-wrap">
        <a-dropdown-button
          :trigger="['click']"
          placement="bottomRight"
          class="float-right"
        >
          <template #overlay>
            <a-menu :selected-keys="currentItem">
              <a-menu-item key="tags">
                <a-button type="primary" class="w-100" @click="openTagsModal">
                  <template #icon>
                    <plus-outlined />
                  </template>
                  Add Tags
                </a-button>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown-button>
      </div>
    </a-col>

    <a-col :span="24">
      <video-list
        ref="videoListRef"
        v-show="currentTab === 0"
        :task-id="task_id"
        :taskName="taskName"
        :video_list="video_list"
        :videos-count="videosCount"
        :sort-by="sortBy"
        :sort-order="sortOrder"
        :loading="loadingVideos"
        :is-meta-files-being-updated="isTaskBeingUpdated"
        :get-video-s3-details="getVideoS3Details"
        :isTask3D="isTask3D"
        :tags="tags"
        :selectedVideo="selectedVideo"
        :currentPage="currentPage"
        :isValidationRecord="isValidationRecord"
        @markVideoValidate="markVideoValidate"
        @handlePlay="handlePlay"
        @updateVideo="updateVideo"
        @annotateVideo="handleAnnotate"
        @annotateLabellingVideo="handleAnnotateLabelling"
        @handleExportMetaFile="handleExportMetaFile"
        @trimVideo="handleTrim"
        @deleteVideo="handleDeleteVideo"
        @updateTaskRecord="updateTaskRecord"
        @sortList="handleSortList"
        @pageChange="handlePageChange"
        @showCommentsModal="showCommentsModal"
        @showTagsModal="showTagsModal"
        @validationToggle="handleValidationToggle"
        @bulkDelete="bulkDeleteVideos"
        @mergeVideos="handleMergeVideos"
      />
    </a-col>
  </a-row>

  <OperationProgress
    v-if="mergeVideoProgress.length"
    :process-list="mergeVideoProgress"
    :process-type="'Merge Video'"
  />
</template>

<script>
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CloseCircleOutlined,
  CloseOutlined,
  DeleteOutlined,
  PlayCircleOutlined,
  PlusOutlined,
  ReloadOutlined,
} from '@ant-design/icons-vue';
import noVideo from 'src/assets/img/no-video.png';
import OperationProgress from 'src/components/shared/Components/OperationProgress.vue';
import Comments from 'src/components/user-panel/pages/trace/Comments.vue';
import spaceMixin from 'src/mixins/handleSpace';
import longRunningTask from 'src/mixins/longRunningTask';
import httpClient from 'src/service/httpClient.js';
import LRTService from 'src/services/longRunningTask';
import { getSortedTask } from 'src/utils/task';
import { mapActions, mapGetters } from 'vuex';
import TelemetryService from '../../../../services/telemetry';
import VideoService from '../../../../services/videos';
import downloadFile from '../../../shared/Helpers/downloadFile';
import getTimeDuration from '../../../shared/Helpers/getDuration';
import timeHelper from '../../../shared/Helpers/timeHelper';
import AnnotationComponentLabelling from '../annotation-labeling/Annotation.vue';
import MergeVideosComponent from '../annotation-labeling/MergeVideos.vue';
import AnnotationComponent from '../annotation/Annotation.vue';
import TrimmingComponent from '../import/Trimming/Trimming.vue';
import { longRunningTaskStatus } from '../process/ObjectDetection/config';
import VideoList from './Videos.vue';

export default {
  components: {
    VideoList,
    AnnotationComponent,
    AnnotationComponentLabelling,
    TrimmingComponent,
    DeleteOutlined,
    PlusOutlined,
    CloseCircleOutlined,
    ArrowRightOutlined,
    ArrowLeftOutlined,
    CloseOutlined,
    Comments,
    PlayCircleOutlined,
    ReloadOutlined,
    MergeVideosComponent,
    OperationProgress,
  },
  mixins: [spaceMixin, longRunningTask],
  inject: ['toast'],
  setup() {
    const userId = localStorage.getItem('id');
    const userName = localStorage.getItem('name');
    return { userId, userName };
  },

  data() {
    return {
      selectedTags: [],
      currentSelectedTag: [],
      tagOptions: [],
      loadingTags: false,
      tags: [],
      activeCommentTagTab: '1',
      currentEntityName: '',
      currentRecordEntityId: null,
      addingComment: false,
      newComment: '',
      comments: [],
      commentsModal: false,
      task_list: [],
      isLoadingTasks: false,
      options: [],
      task_id: undefined,
      taskName: null,
      taskDetails: '',
      isTaskDetailsLoading: false,
      taskJson: null,
      show: false,
      showUploadModal: false,
      selectedVideo: null,
      videosInfo: null,
      videoToTrim: null,
      videoToPlay: null,
      loading: true,
      loadingVideos: false,
      currentTab: 0,
      sortBy: 'id',
      sortOrder: 'ascend',
      isConfirm: null,
      openDeleteVideoDialog: false,
      videoToDelete: null,
      prevMetaData: null,
      //===============  Annotation ============================
      showAnnotationModal: false,
      showAnnotationConfirmModal: false,
      //===============  Annotation Labelling ============================
      showAnnotationLabellingModal: false,
      showAnnotationLabellingConfirmModal: false,
      //===============  Merge Videos ============================
      showMergeVideosModal: false,
      //===============  Trimming ============================
      showTrimModal: false,
      trimProgress: 0,
      isTrimming: false,
      openObjectAnnotateDialog: false,
      isObjectAnnotationModalLoading: false,
      //===========================================
      currentPage: 1,
      currentPageSize: 10,
      searchFilterValue: '',
      searchQuery: {},
      video_list: [],
      videosCount: 0,
      showVideoModal: false,
      isfetchingVideoUrl: false,
      hasFetchCalled: false,
      // ==================
      isNext: true,
      targetNode: '',
      //===========================================
      loadingAnnotationObjects: false,
      objectName: '',
      isCreatingObject: false,
      isObjectStatic: false,
      showObjectModal: false,
      annotationObjects: [],
      optionsForObjects: [],
      organizationTagOptions: [],
      objectsPreferences: [
        {
          label: 'Required',
          value: '-',
        },
        {
          label: 'Optional',
          value: '+',
        },
        {
          label: 'Branched',
          value: '*',
        },
      ],

      //===========================================
      showruleEngineModal: false,
      selectWidth: 200,
      stepsList: [],
      startMarkerForSteps: {},
      endMarkerForSteps: {},
      canFetchRuleEnginejson: false,
      ruleJsonfileName: 'rule-engine.json',
      //===========================================
      log: console.log,
      window: window,
      //===========================================
      activeTab: 'videos',
      imagesForAnnotation: [],
      totalImagesForAnnotation: 0,
      currentPageForImage: 1,
      currentIndexForImage: -1,
      loadingImages: false,
      top: 170,
      noVideo,
      // =================== Tags
      tagsModal: false,
      orgTagsModal: false,
      tagName: '',
      tagDesc: '',
      isLoadingTag: false,
      orgTags: [],
      currentItem: ['tags'],
      ruleInputValue: '',
      rulesList: [],
      objectList: [],
      isTask3D: false,
      isValidationRecord: false,
      // =================== Video Modal Tab & Timestamp Tags
      videoModalActiveTab: 'details',
      currentVideoTime: 0,
      newTagTimestamp: null,
      newTagValue: null,
      videoTimestampTags: [],
      loadingVideoTags: false,
      addingTimestampTag: false,
      deletingTagId: null,
      // New properties to match TimestampTags.vue pattern
      isModelTag: true,
      selectedStep: [],
      newlyCreatedTag: '',
      mergeVideoProgress: [],
      interval: null,
      currentProgressSet: new Set(),
    };
  },

  computed: {
    ...mapGetters([
      'taskTags',
      'organizationTags',
      'selectedTask',
      'isTourRunning',
      'role',
      'organization',
      'isSavingAnnoation',
      'user',
      'isSubstepsChanged',
      'allTasks',
      'isFetchingTasks',
      'isFrameUpdated',
    ]),
    taskOptions() {
      return getSortedTask(this.allTasks);
    },
    isPreviousDisabled() {
      const currentRecordIndex = this.video_list.findIndex(
        (v) => v.fileName === this.videoToPlay?.fileName
      );
      return this.currentPage === 1 && currentRecordIndex === 0;
    },
    isNextDisabled() {
      const currentRecordIndex = this.video_list.findIndex(
        (v) => v.fileName === this.videoToPlay?.fileName
      );

      // Calculate the total number of records in the current pagination context
      const totalRecords = this.videosCount;
      const currentVideoNumber =
        this.currentPage * 10 + currentRecordIndex + 1 - 10;

      // Check if we are at the last record on the last page
      return currentVideoNumber >= totalRecords;
    },

    // Computed properties for timestamp tagging
    getFilteredTagOptions() {
      const filtered = this.organizationTags
        .filter((tag) =>
          this.isModelTag ? tag.tag_type === 'model' : tag.tag_type === 'video'
        )
        .map((tag) => ({
          value: tag.id,
          label: tag.tag_name,
        }));

      // Add newly created tag if it exists
      if (this.newlyCreatedTag) {
        filtered.push({
          value: this.newlyCreatedTag,
          label: this.newlyCreatedTag,
        });
      }

      return filtered;
    },

    stepOptions() {
      // For now, provide some default step options since we don't have substep data
      // In a real implementation, this should come from task details or be passed as props
      return [
        { value: 1, label: '1 - Initial Setup' },
        { value: 2, label: '2 - Processing' },
        { value: 3, label: '3 - Quality Check' },
        { value: 4, label: '4 - Final Assembly' },
        { value: 5, label: '5 - Testing' },
        { value: 6, label: '6 - Packaging' },
      ];
    },

    // Map stepOptions to substepList format expected by TimestampTags logic
    substepList() {
      return this.stepOptions.map((step) => ({
        substepIndex: step.value,
        name: step.label.split(' - ')[1] || step.label, // Extract name part after "1 - "
      }));
    },

    isAllTagsSelected() {
      return this.selectedTags.length === this.organizationTagOptions?.length;
    },
  },

  watch: {
    organizationTags: {
      handler(value) {
        this.organizationTagOptions = value.map((tag) => {
          return {
            value: tag.id,
            label: tag.tag_name,
          };
        });
      },
      deepClone: true,
    },
    showAnnotationConfirmModal(v) {
      // console.log('showAnnotationConfirmModal', v);
    },
    showAnnotationLabellingConfirmModal(v) {
      // console.log('showAnnotationLabellingConfirmModal', v);
    },
    task_id(value) {
      if (!value) return;
      this.setSelectedTask(value);
      this.searchQuery = {
        ...this.searchQuery,
        task: value,
        page: this.currentPage,
      };
      this.setVideosList({ results: [] });
      this.setLongRunningTaskInterval();
      this.sortBy = 'id';
      this.fetchVideos(value);
      this.fetchTaskDetails(value);
      this.set3dCheck(value);
      // this.getTaskDetails(value);
      this.onChangeTask(value);
      this.fetchAssociateBarcodes(value);
      this.setSelectedLanguage('English');
      this.currentIndexForImage = -1;
    },
    allTasks() {
      this.onChangeTask(this.task_id);
    },

    isConfirm(value) {
      if (value === null) return;
      if (value) {
        this.$refs.trim.toggleModal();
      }
      this.isConfirm = null;
      this.$refs.dialog.toggleModal();
    },

    stepsList(value) {
      const temp = {};
      value.forEach((li) => {
        temp[li.name] = [];
      });
      this.startMarkerForSteps = temp;
      this.endMarkerForSteps = temp;
      if (this.canFetchRuleEnginejson) this.fetchRuleEngineJson();
    },
    annotationObjects(value) {
      this.optionsForObjects = value.map(({ name }) => ({
        value: name,
        label: name,
        children: [...this.objectsPreferences],
      }));
    },
    isValidationRecord() {
      this.fetchVideos(this.task_id);
    },

    // video_list(videos) {
    //   if (this.hasFetchCalled) return;
    //   const videosWithoutThumbnail = videos.filter(v => !v.thumbnail_path);
    //   this.fetchAndUpdateThumbnails(videosWithoutThumbnail);
    // },

    currentPage(value) {
      this.searchQuery = { ...this.searchQuery, page: value || 1 };
    },

    // activeTab(value) {
    //   this.searchQuery = { ...this.searchQuery, tab: value };

    //   if (value === 'marking' && this.task_id) {
    //     this.loadImagesForAnnotation(this.task_id);
    //   }
    // },

    searchFilterValue(searchValue) {
      this.searchQuery = { ...this.searchQuery, search: searchValue };
    },

    searchQuery(query) {
      this.updateQueryParams(query);
    },

    showVideoModal(value) {
      if (value && this.organizationTags.length > 0) {
        // Populate tag options from organization tags when modal opens
        this.tagOptions = this.organizationTags.map((tag) => ({
          value: tag.id,
          label: tag.tag_name,
        }));
      }
    },
  },

  async created() {
    console.log('Created Called');

    await this.fetchOrganizationTags();
    this.populateParams();
    this.getAllTasks();
    // Add keyboard shortcuts for timestamp tagging
    window.addEventListener('keydown', this.handleKeyboardShortcuts);
    this.interval = setInterval(this.getMergeVideoProgress, 15000);
  },

  beforeUnmount() {
    this.clearTaskDetails();
    // Remove keyboard event listener to avoid memory leaks
    window.removeEventListener('keydown', this.handleKeyboardShortcuts);
    clearInterval(this.interval);
  },

  methods: {
    ...mapActions([
      'fetchOrganizationTags',
      'setTaskId',
      'stopTour',
      'setSelectedTask',
      'setPrevMetaData',
      'setTaskObjectList',
      'getAllTasks',
      'fetchTaskDetails',
      'setSelectedLanguage',
      'clearTaskDetails',
      'fetchAssociateBarcodes',
    ]),

    markVideoValidate(videoId) {
      this.video_list = this.video_list.map((video) => {
        if (videoId === video.id) {
          video.is_validation_record = !video.is_validation_record;
        }
        return video;
      });
    },

    async getMergeVideoProgress() {
      const taskFilter = {
        name: 'merge_videos',
        task: this.selectedTask,
      };
      const [_, started] = await LRTService.getLongRunningTasks(false, {
        ...taskFilter,
        status: longRunningTaskStatus.STARTED,
      });

      const [error, pending] = await LRTService.getLongRunningTasks(false, {
        ...taskFilter,
        status: longRunningTaskStatus.PENDING,
      });

      this.mergeVideoProgress = [];
      this.getStartedMergeVideoProgress(started);
      this.getPendingMergeVideoProgress(pending);
      await this.getCompletedMergeVideoProgress(started);
    },

    getStartedMergeVideoProgress(started) {
      if (!started) return;
      started.forEach((item) => {
        const payload = {
          id: item.id,
          name: 'Merge Videos',
          status: longRunningTaskStatus.STARTED,
          progress: item.details.progress,
        };
        this.mergeVideoProgress.push(payload);
      });
    },

    getPendingMergeVideoProgress(pending) {
      if (!pending) return;
      pending.forEach((item) => {
        const payload = {
          id: item.id,
          name: 'Merge Videos',
          status: 'Queue',
        };
        this.mergeVideoProgress.push(payload);
      });
    },

    async getCompletedMergeVideoProgress(started) {
      if (!started) return;
      started.forEach(async (item) => {
        if (!this.currentProgressSet.has(item.id))
          this.currentProgressSet.add(item.id);
      });

      if (!started.length && this.currentProgressSet.size) {
        await this.fetchVideos(this.task_id);
        this.currentProgressSet.clear();
        return;
      }

      const startedIds = new Set(started.map((item) => item.id));
      for (const id of this.currentProgressSet) {
        if (!startedIds.has(id)) {
          await this.fetchVideos(this.task_id);
          return;
        }
      }
    },

    async handleTagSelect(val) {
      if (val !== this.selectedTags) this.selectedTags = [];
      this.selectedTags = val;
      // this.$refs.analytics_trace_task_select.blur();

      await this.fetchVideos(this.task_id);
    },

    handleSelectAllTags() {
      if (this.isAllTagsSelected) {
        this.selectedTags = [];
        this.isAllTagsSelected = false;
        return;
      }
      this.selectedTags = this.organizationTagOptions?.map(
        (step) => step.value
      );
      this.isAllTagsSelected = true;
    },

    handleValidationToggle(checked) {
      this.isValidationRecord = checked;
      // Add logic to filter or update table data based on validation
    },

    openTagsModal() {
      this.orgTagsModal = true;
      this.fetchOrgTags();
    },

    isAssociateUserComment(user_data) {
      return user_data.id == this.userId && user_data.username == this.userName
        ? true
        : false;
    },

    async handleTagRemove(tagId) {
      this.loadingTags = true;
      const { entity_id } = this.selectedVideo;
      const entityToDelete = this.tags.find(
        (t) => t.entity_id === entity_id && t.tag_name.id === tagId
      );
      if (!entityToDelete) return;

      const res = await httpClient.delete(
        `organization/entity/tags/`,
        entityToDelete.id,
        false,
        false,
        false
      );
      if (res === 'error') {
        console.log('error occured while removing tag');
      } else {
        this.tags = this.tags.filter(
          (t) => !(t.entity_id === entity_id && t.tag_name.id === tagId)
        );
        const videoEntity = this.video_list.find(
          (t) => t.entity_id === entity_id
        );

        if (videoEntity) {
          videoEntity.tag_count = this.tags.length;
        }
        console.error('error occured while removing tag');
      }

      this.loadingTags = false;
    },

    async fetchOrgTags() {
      this.isLoadingTag = true;
      const res = await httpClient.get('organization/task_record/tags', false);
      this.orgTags = res;
      this.isLoadingTag = false;
    },

    async deleteComment(comment) {
      this.comments = this.comments.filter((t) => t.id !== comment.id);
      const [error] = await VideoService.deleteComment(comment.id);
      if (error) {
        console.error({ error });
        this.toast.error('Error in deleting!');
        return;
      }

      VideoService.decreaseCommentCount(this.selectedVideo);
      const { fileName, no_of_comments } = this.selectedVideo;
      this.updateVideo(fileName, { no_of_comments: no_of_comments - 1 });
      this.selectedVideo = {
        ...this.selectedVideo,
        no_of_comments: no_of_comments - 1,
      };
    },

    async handleAddOrgTag() {
      this.isLoadingTag = true;
      const payload = {
        tag_name: this.tagName,
        descript: this.tagDesc || 'default',
        organization: this.organization,
      };
      const res = await httpClient.post(
        'organization/task_record/tags',
        payload,
        false,
        false,
        false
      );
      this.orgTags = [...this.orgTags, res];
      this.isLoadingTag = false;
      this.tagName = '';
      this.tagDesc = '';
    },

    async createEntity() {
      const payload = {
        name: this.selectedVideo.fileName,
        organization: this.organization,
      };
      return await VideoService.createEntityForVideo(payload);
    },

    async createComment() {
      const paylaod = {
        comment: this.newComment,
        entity_id: this.selectedVideo.entity_id,
        user_id: this.userId,
      };
      return await VideoService.addNewComment(paylaod);
    },

    async handleAddComment() {
      this.addingComment = true;

      if (!this.selectedVideo.entity_id) {
        const res = await this.createEntity();
        const temp = { ...this.selectedVideo };
        temp['entity_id'] = res.id;
        this.selectedVideo = temp;
      }

      const comment_res = await this.createComment();
      comment_res['user_id'] = { id: comment_res.user_id, username: this.user };
      this.comments = [...this.comments, comment_res];

      const { entity_id, no_of_comments } = this.selectedVideo;
      this.updateTaskRecord(
        { entity_id: entity_id, no_of_comments: no_of_comments + 1 },
        this.selectedVideo,
        false
      );
      this.selectedVideo = {
        ...this.selectedVideo,
        no_of_comments: no_of_comments + 1,
      };
      this.addingComment = false;
      this.newComment = '';
    },

    async createTag(tagId) {
      const paylaod = {
        tag_name: tagId,
        entity_id: this.selectedVideo.entity_id,
        user_id: this.userId,
      };

      return await httpClient.post(
        `organization/entity/tags`,
        paylaod,
        false,
        false,
        false
      );
    },

    async handleAddTag(tagId) {
      this.loadingTags = true;
      if (!this.selectedVideo.entity_id) {
        const res = await this.createEntity();
        const temp = { ...this.selectedVideo };
        temp['entity_id'] = res.id;
        this.selectedVideo = temp;
        await this.updateTaskRecord(
          { entity_id: this.selectedVideo.entity_id },
          this.selectedVideo,
          false
        );
      }

      const tag_res = await this.createTag(tagId);
      tag_res['tag_name'] = this.orgTags.find(
        (ot) => ot.id === tag_res.tag_name
      );

      this.tags = [...this.tags, tag_res];

      const videoEntity = this.video_list.find(
        (t) => t.entity_id === this.selectedVideo.entity_id
      );

      if (videoEntity) {
        videoEntity.tag_count = this.tags.length;
      }
      this.loadingTags = false;
    },

    cacheImage(img) {
      this.imagesForAnnotation[this.currentIndexForImage].loadedImage = img;
    },

    showTagsModal(data) {
      this.selectedVideo = data.taskRecord;
      this.orgTags = data.orgTags;
      this.tags = data.entityTag;
      this.currentSelectedTag = data.entityTag.map((e) => e.tag_name.id);
      this.tagOptions = data.orgTags.map((el) => ({
        value: el.id,
        label: el.tag_name,
      }));
      this.tagsModal = true;
    },

    showCommentsModal(data) {
      this.selectedVideo = data.taskRecord;
      this.comments = data.comments;
      this.commentsModal = true;
    },

    generateNextAndPrevIndices(index) {
      let indexList = [];
      for (let itr = index - 10; itr !== index; itr++) {
        if (itr >= 0) indexList.push(itr);
      }
      for (
        let itr = index + 1;
        itr < this.imagesForAnnotation.length && itr <= index + 10;
        ++itr
      )
        indexList.push(itr);
      return indexList;
    },

    async updateImageIndex(index) {
      this.currentIndexForImage = index;
      const iterations = this.generateNextAndPrevIndices(index);
      for await (const itr of iterations) {
        if (!this.imagesForAnnotation[itr].loadedImage) {
          const imageUrl = await this.getImageUrl(
            this.organization + '-training',
            this.imagesForAnnotation[itr].path_to_image
          );

          this.imagesForAnnotation[itr].loadedImage =
            await this.getImageFromSrc(imageUrl);
        }
      }
    },

    getImageFromSrc(src) {
      return new Promise(async (resolve) => {
        const image = new window.Image();
        image.src = src;
        image.onload = () => resolve(image);
      });
    },

    async getImageUrl(bucket, path_to_image) {
      const { presigned_url } = await httpClient.post(
        'generic/generate_new_url/',
        { bucket_name: bucket, object_path: path_to_image },
        false,
        false,
        false
      );
      return presigned_url;
    },

    updateImageAnnotationPath(image) {
      this.imagesForAnnotation[this.currentIndexForImage].path_to_annotations =
        image.path_to_annotations;
    },

    finishTrimming() {
      this.showTrimModal = false;
      this.fetchVideos(this.task_id);
      this.trimProgress = 0;
      this.isTrimming = false;
    },

    closeObjectAnnotationModal() {
      this.openObjectAnnotateDialog = false;
    },

    openObjectAnnotationModal(record) {
      this.openObjectAnnotateDialog = true;
      this.selectedVideo = { ...record };
    },

    populateParams() {
      const { task, tab, page, search } = this.$route.query;
      this.currentPage = Number(page) || 1;
      const taskId = task || this.selectedTask;
      this.searchFilterValue = search ? search : '';
      this.activeTab = tab || 'videos';
      this.task_id = taskId && Number(taskId);
    },

    async fetchAndUpdateThumbnails(videosWithoutThumbnail) {
      this.hasFetchCalled = true;
      for await (const video of videosWithoutThumbnail) {
        const url = await this.getVideoUrl(video);
        const { bucket, filePath: path } = this.getVideoS3Details(video);
        const { thumbnail_path } = await this.getThumbnailPath(
          url,
          bucket,
          path
        );
        if (thumbnail_path)
          await this.updateTaskRecord({ thumbnail_path }, video, false);
        else {
          this.updateVideo(video.fileName, { noVideo });
        }
      }
      this.hasFetchCalled = false;
    },

    async getThumbnailPath(file_url, bucket_name, file_path) {
      const payload = {
        file_url,
        bucket_name,
        file_path,
      };
      return await httpClient.post(
        'generic/create_thumbnail/',
        payload,
        false,
        false,
        false
      );
    },

    markerContainerWidth(marker) {
      let count = 0;
      Object.values(this[marker]).forEach((el) => {
        count = el.length > count ? el.length : count;
      });
      return count * this.selectWidth + 'px';
    },

    async getTaskObjects(taskId) {
      const res = await httpClient.get(
        `organization/task/list_task_objects/${taskId}/`
      );
      if (res === 'error') return;

      this.annotationObjects = res;
      this.setTaskObjectList(res);
    },

    addObjectToStep(stepName, position) {
      const temp = { ...this[position] };
      if (temp[stepName] && temp[stepName].length === 0) {
        temp[stepName] = [undefined, undefined];
      } else if (temp[stepName]) {
        temp[stepName].push(undefined);
      }
      this[position] = temp;
    },

    removeObjectFromStep(stepName, objectIndex, position) {
      const temp = { ...this[position] };
      if (temp[stepName].length === 2) {
        temp[stepName] = [];
      } else {
        temp[stepName] = temp[stepName].filter(
          (_, index) => index !== objectIndex
        );
      }
      this[position] = temp;
    },

    handleChangeObject(value, stepName, objectIndex, position) {
      const temp = { ...this[position] };
      temp[stepName][objectIndex] = value;
      this[position] = temp;
    },

    openruleEngineModal() {
      this.showruleEngineModal = true;
      this.fetchRuleEngineJson();
    },

    async fetchRuleJsonUrl() {
      const bucket = `${this.organization}-training`;
      const filePath = `${this.taskName}/Detector/${this.ruleJsonfileName}`;

      return await this.fetchPresignedUrl(bucket, filePath);
    },

    getObjsWithOps(prevJson, step, marker) {
      return prevJson[step.name][marker].map((el) => [el.substr(1), el[0]]);
    },

    getMarkedObjects(step, markerType) {
      return this[markerType][step.name].map(([obj, pref]) => pref + obj);
    },

    getRuleEnginePayload(json) {
      var formData = new FormData();
      const bucket = `${this.organization}-training`;
      const filePath = `${this.taskName}/Detector/${this.ruleJsonfileName}`;
      var blob = new Blob([json], { type: 'text/json;charset=utf-8' });
      formData.append('file', blob, this.ruleJsonfileName);
      formData.append('file_path', filePath);
      formData.append('bucket', bucket);
      return formData;
    },

    openAnnotationObjectModal() {
      this.showObjectModal = true;
    },

    getObjectPayload() {
      return {
        name: this.objectName,
        is_static: this.isObjectStatic,
        task: this.task_id,
      };
    },

    async handleObjectAdd() {
      const payload = this.getObjectPayload();

      this.isCreatingObject = true;
      const res = await httpClient.post(
        'organization/task/task_object/',
        payload
      );
      this.isCreatingObject = false;

      if (res === 'error') return;
      this.annotationObjects = [...this.annotationObjects, res];
      this.setTaskObjectList(this.annotationObjects);
      this.objectName = '';
      this.isObjectStatic = false;
    },

    async removeObject(id) {
      this.loadingAnnotationObjects = true;
      const res = await httpClient.delete(
        'organization/task/task_object/',
        id + '/',
        false
      );
      this.loadingAnnotationObjects = false;
      if (res === 'error') return;

      const temp = [...this.annotationObjects];
      this.annotationObjects = temp.filter((object) => object.id !== id);
      this.setTaskObjectList(this.annotationObjects);
    },

    checkIfNodeExists(stepIndex) {
      if (!this.steps[stepIndex]) return;
      const { target } = this.steps[stepIndex];
      const node = document.querySelector(target);
      this.targetNode = target;
      this.isNext = !!node;
    },

    taskCompUpdate() {
      if (this.targetNode) {
        this.isNext = !!document.querySelector(this.targetNode);
      }
    },

    updateTaskJsonEmit(taskJson) {
      this.taskJson = taskJson;
    },

    onChangeTask(task_id) {
      this.taskName = this.allTasks.find((el) => el.id === task_id)?.taskName;
      // this.taskName = this.task_list.find((el) => el.id === task_id)?.taskName;
      this.setTaskId(task_id);
    },

    changeTab(current) {
      if (!this.task_id) return;
      this.currentTab = current;
    },

    getUrl(taskId, page, pageSize, search) {
      let url = 'organization/task/upload/' + taskId + '/?';
      const orderMapping =
        {
          ascend: '',
          descend: '-',
        }[this.sortOrder] || '';
      url = page > 1 ? `${url}page=${page}&` : url;
      if (this.isValidationRecord) {
        url += `is_validation_record=${this.isValidationRecord}&`;
      }
      if (pageSize) {
        url += `page_size=${pageSize}&`;
      }

      if (search) {
        url += `isUploadedVideo=true&search=${search}&`;
        return url;
      }
      if (this.selectedTags.length) {
        url += `selectedTag=${JSON.stringify(this.selectedTags)}&`;
        return url;
      }
      const orderBy = `${orderMapping}${this.sortBy}`;
      url += `ordering=${orderBy}`;
      return url;
    },

    async fetchVideos(taskId) {
      let url = this.getUrl(
        taskId,
        this.currentPage,
        this.currentPageSize,
        this.searchFilterValue
      );
      this.loadingVideos = true;
      const res = await httpClient.getData(url, false);
      this.loadingVideos = false;
      if (res === 'error') {
        this.searchQuery = { ...this.searchQuery, task: this.task_id, page: 1 };
        this.currentPage = 1;
        await this.handlePageChange({ current: this.currentPage });
        this.video_list = [];
        return;
      }
      this.setVideosList(res);
      return res;
    },

    setVideosList(res) {
      this.video_list = res.results.map((v) => ({
        ...v,
        isThumbnailExist: true,
      }));
      this.videosCount = res.count || 0;
    },

    updateQueryParams(query) {
      query = {
        ...this.$route.query,
        ...query,
      };
      this.$router.replace({
        name: this.$route.name,
        query,
      });
    },

    async handlePageChange({
      page,
      pageSize,
      filterValue = this.searchFilterValue,
    }) {
      this.currentPage = page;
      this.currentPageSize = pageSize;
      this.searchFilterValue = filterValue;
      console.log('Page changed to:', page);
      console.log('Page size changed to:', pageSize);
      console.log('Filter value changed to:', filterValue);
      await this.fetchVideos(this.task_id);
    },

    handleSortList({ field, order }) {
      this.sortBy = order ? field : '';
      this.sortOrder = order;
      this.fetchVideos(this.task_id);
    },

    getSortOrder(a, b, field, sortOrder) {
      let orders = {};

      if (field === 'duration') {
        orders = {
          asc: () => getTimeDuration(a[field]) - getTimeDuration(b[field]),
          des: () => getTimeDuration(b[field]) - getTimeDuration(a[field]),
        };
      } else if (field === 'fileName') {
        orders = {
          asc: () => -1,
          des: () => -1,
        };
      } else {
        orders = {
          asc: () => a[field] - b[field],
          des: () => b[field] - a[field],
        };
      }
      return orders[sortOrder]();
    },

    updateVideo(videoName, updatedObj) {
      const temp = [...this.video_list];
      const index = temp.findIndex((v) => v.fileName === videoName);
      if (temp[index]) {
        temp[index] = {
          ...temp[index],
          ...updatedObj,
        };
      }
      this.video_list = temp;
    },

    getVideoS3Details(video) {
      const { fileName } = video;
      const bucket = `${this.organization}-training`;
      const filePath = `${this.taskName}/Videos/${fileName}`;
      return { bucket, filePath };
    },

    async fetchPresignedUrl(bucket_name, object_path) {
      const payload = {
        bucket_name,
        object_path,
      };
      return new Promise(async (resolve) => {
        const res = await httpClient.post(
          'generic/generate_new_url/',
          payload,
          false,
          false,
          false
        );
        resolve(res.presigned_url || res);
      });
    },

    async getVideoUrl(video) {
      const { bucket, filePath } = this.getVideoS3Details(video);
      return await this.fetchPresignedUrl(bucket, filePath);
    },

    async handlePlayNext(record) {
      // Find the index of the current record
      const currentRecordIndex = this.video_list.findIndex(
        (v) => v.fileName === record.fileName
      );

      const totalRecords = this.videosCount;
      const currentVideoNumber =
        this.currentPage * 10 + currentRecordIndex + 1 - 10;

      // Check if we have reached the end of the available records
      if (currentVideoNumber >= totalRecords) {
        console.warn('No more records to play.');
        return;
      }

      // Get the next record, if available
      let nextRecord =
        currentRecordIndex !== -1
          ? this.video_list[currentRecordIndex + 1]
          : null;

      if (!nextRecord) {
        // If no next record, fetch the next page of results
        this.currentPage += 1;
        this.searchFilterValue = this.searchFilterValue; // Assuming this is necessary for the fetch
        const { results } = await this.fetchVideos(this.task_id);

        // Set nextRecord to the first result from the new fetch
        nextRecord = results[0] || null;
      }

      if (nextRecord) {
        this.handlePlay(nextRecord);
      } else {
        console.warn('No next record found to play.');
      }
    },

    async handlePlayPrevious(record) {
      // Find the index of the current record
      const currentRecordIndex = this.video_list.findIndex(
        (v) => v.fileName === record.fileName
      );

      // Check if we're at the first record on the first page
      if (this.currentPage === 1 && currentRecordIndex === 0) {
        console.warn('Already at the first record. Cannot go previous.');
        return;
      }

      // Determine the previous record index
      let previousRecordIndex = currentRecordIndex - 1;

      // Handle pagination: check if we need to go to the previous page
      let response = [];
      if (previousRecordIndex < 0) {
        if (this.currentPage > 1) {
          this.currentPage -= 1;
          const { results } = await this.fetchVideos(this.task_id);
          response = results;

          // Set previousRecordIndex to the last record of the previous page
          previousRecordIndex = results.length - 1; // Assuming results are sorted correctly
        } else {
          console.warn('No previous records available.');
          return;
        }
      }

      // Get the previous record
      const previousRecord = response.length
        ? response[previousRecordIndex]
        : this.video_list[previousRecordIndex];

      if (previousRecord) {
        this.handlePlay(previousRecord);
      } else {
        console.warn('No previous record found to play.');
      }
    },

    async handlePlay(video) {
      if (!video?.fileName || video.noVideo) {
        this.toast.error(`${video.fileName} is not found!`);
        return;
      }

      this.showVideoModal = true;
      if (!video.fileURL) {
        this.isfetchingVideoUrl = true;
        let presignedUrl = await this.getVideoUrl(video);
        if (this.organization === 'celestica') {
          presignedUrl = presignedUrl.replace(
            '.us-east-2.',
            '.ap-southeast-1.'
          );
        }
        this.isfetchingVideoUrl = false;
        if (presignedUrl === 'error') {
          this.toast.error('Error occured while fetching url!');
          return;
        }
        video = { ...video, fileURL: presignedUrl };
      }
      this.videoToPlay = { ...video };

      // Fetch timestamp tags for this video
      await this.getVideoTimestampTags();
    },

    async handleVideoModalClose() {
      this.updateVideo(this.videoToPlay.fileName, this.videoToPlay);
      // Reset video modal state
      this.videoModalActiveTab = 'details';
      this.currentVideoTime = 0;
      this.newTagTimestamp = null;
      this.newTagValue = null;
      this.videoTimestampTags = [];
    },

    openUploadingModal() {
      this.showUploadModal = true;
      setTimeout(this.$refs.vTour.nextStep, 500);
    },

    async handleAnnotateNavigate() {
      if (this.isFrameUpdated) {
        this.emitter.emit('save-label');
        let response = await this.getPrevMetaData();
        if (response === 403) {
          this.toast.info('Please wait 10 seconds to label the video again');
          return;
        }
        if (['error', 403].includes(response)) return;
        if (response.error === 'NoSuchKey') {
          this.setPrevMetaData(null);
        } else {
          this.setMetaData(response);
        }
      }
      this.handleAnnotateViewFlag();
    },
    async handleAnnotateLabellingNavigate() {
      if (this.isSubstepsChanged) {
        this.emitter.emit('save-label');
        let response = await this.getPrevMetaData();
        if (response === 403) {
          this.toast.info('Please wait 10 seconds to label the video again');
          return;
        }
        if (['error', 403].includes(response)) return;
        if (response.error === 'NoSuchKey') {
          this.setPrevMetaData(null);
        } else {
          this.setMetaData(response);
        }
      }
      this.handleAnnotateLabellingViewFlag();
    },
    async handleAnnotateViewFlag() {
      this.showAnnotationModal = true;
      this.showAnnotationLabellingModal = false;
    },
    async handleAnnotateLabellingViewFlag() {
      this.showAnnotationLabellingModal = true;
      this.showAnnotationModal = false;
    },
    async handleMergeVideosViewFlag() {
      this.showMergeVideosModal = true;
    },
    async fetchInfo(video) {
      if (!video.fileURL) {
        const presignedUrl = await this.getVideoUrl(video);
        video = { ...video, fileURL: presignedUrl };
      }
      this.selectedVideo = { ...video };
      let response = await this.getPrevMetaData();
      if (response === 403) {
        this.toast.info('Please wait 10 seconds to label the video again');
        return;
      }
      if (['error', 403].includes(response)) return;
      if (response.error === 'NoSuchKey') {
        this.setPrevMetaData(null);
      } else {
        this.setMetaData(response);
      }
    },
    async fetchVideosInfo(videos) {
      const videosInfo = [];

      for (const video of videos) {
        let updatedVideo = { ...video };

        if (!video.fileURL) {
          const presignedUrl = await this.getVideoUrl(video);
          updatedVideo.fileURL = presignedUrl;
        }

        videosInfo.push(updatedVideo);
      }
      this.videosInfo = videosInfo;
    },
    async handleAnnotate(video) {
      await this.fetchInfo(video);
      this.handleAnnotateViewFlag();
      // await this.emitter.emit('save-label');
    },
    async handleAnnotateLabelling(video) {
      await this.fetchInfo(video);
      this.handleAnnotateLabellingViewFlag();
    },

    async handleMergeVideos(videos) {
      await this.fetchVideosInfo(videos);
      this.handleMergeVideosViewFlag();
    },

    getPreMetaDataUrl() {
      const organization =
        this.role === 'admin' ? null : localStorage.getItem('organization');
      console.log('organization', organization);
      const url = `organization/task/upload/retrieve_metadata?org=${organization}&task_name=${
        this.taskName
      }&video_name=${this.selectedVideo?.fileName.replaceAll(
        '+',
        '%2B'
      )}&task_id=${this.task_id}`;
      return url;
    },

    async getPrevMetaData() {
      if (!this.selectedVideo) return;
      const url = this.getPreMetaDataUrl();
      const { fileName } = this.selectedVideo;

      this.updateVideo(fileName, { loadingAnnotation: true });
      let response = await httpClient.getData(url, false);
      this.updateVideo(fileName, { loadingAnnotation: false });

      return response;
    },

    showAnnotationConfirm() {
      if (this.isSubstepsChanged) {
        this.showAnnotationConfirmModal = true;
      } else this.handleAnnotationClose();
    },
    showAnnotationLabelConfirm() {
      this.handleAnnotationCloseLabel();
    },
    handleAnnotationCloseLabel() {
      this.showAnnotationConfirmModal = false;
      this.showAnnotationLabellingConfirmModal = false;
      this.showAnnotationModal = false;
      this.showAnnotationLabellingModal = false;
      this.loading = true;
    },
    handleMergeVideosCloseLabel() {
      this.showMergeVideosModal = false;
      this.videosInfo = null;
      this.loading = true;
      this.$refs.videoListRef.clearSelectedVideos();
    },

    handleAnnotationClose() {
      this.showAnnotationConfirmModal = false;
      this.showAnnotationLabellingConfirmModal = false;
      this.showAnnotationModal = false;
      this.showAnnotationLabellingModal = false;
      this.loading = true;
      this.selectedVideo.fileName = '';
      this.selectedVideo.selectedVideo = '';
      this.selectedVideo.fileURL = '';
    },

    setMetaData(response) {
      if (typeof response === 'string') {
        response = response.replaceAll('Infinity', Number.MAX_SAFE_INTEGER);
        const parsedResponse = JSON.parse(response);
        this.setPrevMetaData(parsedResponse);
      } else {
        this.setPrevMetaData(response);
      }
    },

    async handleExportMetaFile(video) {
      this.selectedVideo = { ...video };
      const url = this.getPreMetaDataUrl();
      let metaData = await httpClient.getData(url);
      downloadFile(video.fileName, 'json', JSON.stringify(metaData));
    },

    async handleTrim(video) {
      this.showTrimModal = true;
      if (!video.fileURL) {
        const presignedUrl = await this.getVideoUrl(video);
        video = { ...video, fileURL: presignedUrl };
      }
      this.videoToTrim = { ...video };
    },

    handleLabelling({ data, isEmptyJson }) {
      this.showAnnotationConfirmModal = false;
      this.showAnnotationLabellingConfirmModal = false;
      this.loading = true;
      this.showAnnotationModal = false;
      this.showAnnotationLabellingModal = false;
      if (isEmptyJson) return;
      const { labelled, fileName } = data;
      const temp = [...this.video_list];
      const index = temp.findIndex((v) => v.fileName === fileName);
      temp[index].labelled = labelled;
      this.video_list = temp;
    },

    handleTrimModalClose() {
      this.updateVideo(this.videoToTrim.fileName, this.videoToTrim);
      this.videoToTrim = null;
      this.loading = true;
    },

    handleUploadModalClose() {
      setTimeout(this.$refs.vTour.nextStep, 500);
    },

    async handleDeleteVideo(video) {
      const res = await httpClient.delete(
        'organization/task_record/',
        video.id + '/'
      );
      if (res === 'error') {
        console.error('error occured while deleting a video');
        return;
      } else {
        this.video_list.length === 1
          ? await this.handlePageChange({ current: this.currentPage - 1 })
          : await this.fetchVideos(this.task_id);
      }
    },

    async bulkDeleteVideos() {
      this.currentPage = 1;
      this.fetchVideos(this.task_id);
    },

    async updateTaskRecord(updatedData, videoToUpdate, alert = true) {
      this.updateVideo(videoToUpdate.fileName, updatedData);
      const [error] = await VideoService.updateTaskRecord(
        videoToUpdate.id,
        updatedData
      );
      if (error && alert) {
        this.toast.error('Error occured while updating the record!');
      }
      if (alert) this.toast.success('Record updated successfully!');
    },

    handlePageChangeImages(page) {
      this.currentPageForImage = page;
      this.loadImagesForAnnotation(this.task_id);
    },

    async loadImagesForAnnotation(taskId) {
      this.loadingImages = true;
      const res = await httpClient.getData(
        `organization/task/annotation_image_list/${taskId}/?page=${this.currentPageForImage}`,
        false
      );
      this.loadingImages = false;
      if (res === 'error') {
        this.toast.error('error in getting images');
        return;
      }
      this.imagesForAnnotation = res.results;
      this.totalImagesForAnnotation = res.count;
    },

    handleAddRule() {
      const newRuleObj = {
        rule: this.ruleInputValue,
        objects: this.objectList,
      };
      this.rulesList = [...this.rulesList, newRuleObj];
      this.ruleInputValue = '';
      this.objectList = [];
    },

    handleAddObject() {
      const objList = [...this.objectList, undefined];
      this.objectList = objList;
    },

    handleSelectObjectValue(value, position) {
      const temp = [...this.objectList];
      temp[position] = value;
      this.objectList = [...temp];
    },

    async set3dCheck(taskId) {
      const res = await httpClient.getData(
        `organization/task/is_3d/${taskId}/`
      );
      if (res === 'error') return;
      this.isTask3D = res?.is_3d;
    },

    // =================== Video Modal Tab & Timestamp Tags Methods
    handleVideoTimeUpdate(event) {
      this.currentVideoTime = event.target.currentTime;
    },

    handleKeyboardShortcuts(event) {
      // Only handle shortcuts when video modal is open and on tags tab
      if (!this.showVideoModal || this.videoModalActiveTab !== 'tags') return;

      if (event.ctrlKey && event.key === 'a') {
        event.preventDefault();
        // Toggle tag type
        this.isModelTag = !this.isModelTag;
        this.handleTagSwitchChange();
      } else if (event.ctrlKey && event.key === ' ') {
        event.preventDefault();
        // Add tag at current time
        this.addTimestampTag();
      }
    },

    formatTime(seconds) {
      if (!seconds && seconds !== 0) return '00:00';
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = Math.floor(seconds % 60);
      return `${minutes.toString().padStart(2, '0')}:${remainingSeconds
        .toString()
        .padStart(2, '0')}`;
    },

    convertToMmSs(timeStamp) {
      return timeHelper.convertToMMSS(timeStamp?.split('.')[0]);
    },

    parseTimeToSeconds(timeStamp) {
      return timeHelper.formatMmSsToSeconds(this.convertToMmSs(timeStamp));
    },

    formatRelativeTime(dateString) {
      const dayjs = require('dayjs');
      const relativeTime = require('dayjs/plugin/relativeTime');
      dayjs.extend(relativeTime);
      return dayjs(new Date(dateString)).fromNow();
    },

    getTagName(tagId) {
      const tag = this.organizationTags.find((t) => t.id === tagId);
      return tag ? tag.tag_name : 'Unknown Tag';
    },

    handleTagSwitchChange() {
      this.selectedStep = [];
      this.newTagValue = null;
      this.newlyCreatedTag = '';
    },

    filterOption(input, option) {
      return option.label.toLowerCase().includes(input.toLowerCase());
    },

    onTagSearch(value) {
      // Set newly created tag if searching for non-existing tag
      this.newlyCreatedTag = value;
    },

    onTagChange(value) {
      // Reset newly created tag when selecting existing option
      if (value !== this.newlyCreatedTag) {
        this.newlyCreatedTag = '';
      }
    },

    checkIfTagExists(tagId) {
      const currentTimeFormatted = timeHelper.formatSecondsToHhMmSs(
        this.currentVideoTime
      );
      return this.videoTimestampTags.some(
        (el) =>
          el.tag === tagId &&
          el.time_stamp === currentTimeFormatted &&
          (this.selectedStep.length === 0 ||
            this.selectedStep.includes(el.step_index))
      );
    },

    async createNewTag(tagName) {
      const maxLength = 30;
      const validCharsPattern = /^[a-zA-Z0-9 _-]+$/;

      if (tagName.length > maxLength) {
        this.toast.error(`Tag must be ${maxLength} characters or fewer.`);
        return null;
      }

      if (!validCharsPattern.test(tagName)) {
        this.toast.error(
          'Tag can only contain letters, numbers, spaces, hyphens (-), and underscores (_).'
        );
        return null;
      }

      const payload = {
        tag_name: tagName,
        descript: 'default',
        organization: this.organization,
        tag_type: this.isModelTag ? 'model' : 'video',
      };

      const [error, data] = await VideoService.createOrganizationTag(payload);
      if (error) {
        this.toast.error(`Unable to create '${tagName}'`);
        return null;
      }

      // Add to local organizationTags array
      this.organizationTags.push(data);
      return data;
    },

    async addTimestampTag() {
      if (!this.newTagValue) {
        this.toast.error('Please select a tag');
        return;
      }

      // Allow currentVideoTime to be 0 (start of video)
      if (typeof this.currentVideoTime !== 'number') {
        this.toast.error('Please ensure video is loaded');
        return;
      }

      this.addingTimestampTag = true;

      try {
        let tagId = this.newTagValue;

        // Handle new tag creation if it's a string
        if (typeof tagId === 'string') {
          const newTag = await this.createNewTag(tagId);
          if (!newTag) {
            this.addingTimestampTag = false;
            return;
          }
          tagId = newTag.id;

          this.organizationTagOptions = [
            ...this.organizationTagOptions,
            {
              value: newTag.id,
              label: newTag.tag_name,
            },
          ];
        }

        // Handle multiple steps for Model Tags
        if (this.isModelTag && this.selectedStep.length > 1) {
          // Multiple steps selected
          const selectedSteps = this.selectedStep.map((step) => {
            const payload = {
              ...(tagId && { tag: tagId }),
              step_name: this.substepList.find(
                (data) => data.substepIndex == step
              )?.name,
              step_index: step,
              organization: this.organization,
              task_record: this.videoToPlay.id,
              time_stamp: timeHelper.formatSecondsToHhMmSs(
                this.currentVideoTime
              ),
              added_by: localStorage.getItem('id'),
            };
            return TelemetryService.addTimeStampTags(payload);
          });

          const results = await Promise.all(selectedSteps);
          const hasError = results.some(([error]) => error);

          if (hasError) {
            this.toast.error('Some tags could not be added');
          } else {
            this.toast.success(
              `${this.selectedStep.length} tags added successfully`
            );
          }
        } else {
          // Single step or no step
          const payload = {
            ...(tagId && { tag: tagId }),
            ...(this.isModelTag &&
              this.selectedStep.length > 0 && {
                step_name: this.substepList.find(
                  (data) => data.substepIndex == this.selectedStep[0]
                )?.name,
                step_index: this.selectedStep[0],
              }),
            organization: this.organization,
            task_record: this.videoToPlay.id,
            time_stamp: timeHelper.formatSecondsToHhMmSs(this.currentVideoTime),
            added_by: localStorage.getItem('id'),
          };

          const [error] = await TelemetryService.addTimeStampTags(payload);

          if (error) {
            this.toast.error('Unable to add tag');
          } else {
            this.toast.success('Tag added successfully');
          }
        }

        // Reset form
        this.newTagValue = null;
        this.selectedStep = [];
        this.newlyCreatedTag = '';

        // Refresh tags list
        await this.getVideoTimestampTags();
      } catch (error) {
        console.error('Error adding timestamp tag:', error);
        this.toast.error('An error occurred while adding the tag');
      } finally {
        this.addingTimestampTag = false;
      }
    },

    async getVideoTimestampTags() {
      if (!this.videoToPlay?.id) return;

      this.loadingVideoTags = true;
      try {
        const [error, data] = await TelemetryService.getTimeStampTags(
          this.videoToPlay.id
        );
        if (error) {
          this.toast.error('Unable to fetch timestamp tags');
          return;
        }

        this.videoTimestampTags = data || [];
      } catch (error) {
        console.error('Error fetching timestamp tags:', error);
        this.toast.error('Error fetching timestamp tags');
      } finally {
        this.loadingVideoTags = false;
      }
    },

    async refreshTags() {
      await this.getVideoTimestampTags();
      this.toast.success('Tags refreshed!');
    },

    getModelTagCount() {
      return this.videoTimestampTags.filter((tag) => {
        const orgTag = this.organizationTags.find((t) => t.id === tag.tag);
        return orgTag && orgTag.tag_type === 'model';
      }).length;
    },

    getVideoTagCount() {
      return this.videoTimestampTags.filter((tag) => {
        const orgTag = this.organizationTags.find((t) => t.id === tag.tag);
        return orgTag && orgTag.tag_type === 'video';
      }).length;
    },

    getTagType(tagId) {
      const orgTag = this.organizationTags.find((t) => t.id === tagId);
      return orgTag ? orgTag.tag_type : 'unknown';
    },

    async deleteTimestampTag(tagId) {
      this.deletingTagId = tagId;

      try {
        const [error] = await TelemetryService.removeTimeStampTags(tagId);
        if (error) {
          this.toast.error('Unable to remove tag');
          return;
        }

        this.toast.success('Tag removed successfully');
        // Refresh the tags list
        await this.getVideoTimestampTags();
      } catch (error) {
        console.error('Error deleting timestamp tag:', error);
        this.toast.error('Error deleting tag');
      } finally {
        this.deletingTagId = null;
      }
    },

    seekToTimestamp(timestamp) {
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.currentTime = timestamp;
        this.$refs.videoPlayer.play();
      }
    },

    parseTimeToSeconds(timeString) {
      // timeString is in format "HH:MM:SS" or "MM:SS"
      // Convert to seconds for video seeking
      const parts = timeString.split(':');
      if (parts.length === 3) {
        // HH:MM:SS format
        return (
          parseInt(parts[0]) * 3600 +
          parseInt(parts[1]) * 60 +
          parseInt(parts[2])
        );
      } else if (parts.length === 2) {
        // MM:SS format
        return parseInt(parts[0]) * 60 + parseInt(parts[1]);
      }
      return 0;
    },
  },
};
</script>
<style>
.objects-container {
  height: 50vh;
  margin-top: 1em;
  overflow: auto;
}

.ant-modal-footer {
  display: flex;
}

.bold {
  font-weight: 600;
}

/* Video Modal Tab Styles */
.video-tags-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.video-tags-container h4 {
  margin-bottom: 12px;
  font-weight: 600;
}

.video-tags-container .ant-row {
  margin-bottom: 8px;
}

.video-tags-container .border {
  border: 1px solid #d9d9d9;
}

.video-tags-container .rounded {
  border-radius: 6px;
}

.video-tags-container .p-3 {
  padding: 12px;
}

.video-tags-container .mb-3 {
  margin-bottom: 16px;
}

.video-tags-container .mb-2 {
  margin-bottom: 8px;
}

.video-tags-container .text-muted {
  color: #8c8c8c;
}

.video-tags-container .text-center {
  text-align: center;
}

.video-tags-container .ml-2 {
  margin-left: 8px;
}

.video-tags-container .font-weight-bold {
  font-weight: 600;
}

/* Flex utilities for better layout */
.flex-grow-1 {
  flex-grow: 1;
}

/* Timestamp tag item styling */
.timestamp-tag-item {
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-radius: 6px;
  padding: 4px 8px;
  margin-bottom: 4px;
}

.timestamp-tag-item:hover {
  background-color: #f0f2f5;
  transform: translateX(2px);
}

/* Tag display styling */
.timestamp-tag {
  font-family: monospace;
  font-weight: 600;
  margin-right: 8px;
}

.tag-name {
  font-weight: 500;
  margin-right: 8px;
}

.step-tag {
  font-size: 12px;
  margin-right: 4px;
}

/* Tags container */
.tags-container {
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  padding: 8px;
  background-color: #fafafa;
}

/* Legacy wrapper - replaced by tags-scrollable-container */

/* Tag toggle controls styling */
.tag-selection {
  display: flex;
  gap: 8px;
  align-items: center;
}

.tag-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Utility classes for spacing */
.mr-2 {
  margin-right: 8px;
}

.mb-0 {
  margin-bottom: 0;
}

.text-right {
  text-align: right;
}

.py-4 {
  padding: 16px 0;
}

.mt-2 {
  margin-top: 8px;
}

/* Responsive adjustments for two-column layout */
@media (max-width: 768px) {
  .tags-main-row {
    flex-direction: column;
    height: auto;
  }

  .tags-add-column,
  .tags-list-column {
    height: auto;
    min-height: 250px;
  }

  .tags-controls-container,
  .tags-list-container {
    padding: 12px;
    margin-bottom: 16px;
  }

  .tags-scrollable-container {
    min-height: 200px;
  }

  .timestamp-tag-item {
    padding: 8px;
  }

  .tag-name,
  .step-tag {
    font-size: 12px;
  }

  .tags-list-scrollable {
    padding: 4px;
  }
}

@media (max-width: 480px) {
  .tags-add-column,
  .tags-list-column {
    min-height: 200px;
  }

  .tags-scrollable-container {
    min-height: 150px;
  }

  .timestamp-tag,
  .tag-name,
  .step-tag {
    font-size: 11px;
    margin-right: 4px;
  }

  .timestamp-tag-item {
    padding: 6px;
  }
}

/* Ensure tabs container works properly with flex layout */
.ant-tabs.flex-grow-1 {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.ant-tabs.flex-grow-1 .ant-tabs-content-holder {
  flex: 1;
  overflow: hidden;
}

.ant-tabs.flex-grow-1 .ant-tabs-content {
  height: 100%;
  overflow: hidden;
}

.ant-tabs.flex-grow-1 .ant-tabs-tabpane {
  height: 100%;
  overflow: hidden;
}

/* Legacy containers - replaced by two-column layout */

/* Video tags container - two-column layout */
.video-tags-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.tags-main-row {
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
}

.tags-add-column,
.tags-list-column {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.tags-controls-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background-color: #fafafa;
}

.tags-list-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background-color: #fafafa;
}

.tags-scrollable-container {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  background-color: #ffffff;
  scrollbar-width: thin;
  scrollbar-color: #bfbfbf #f5f5f5;
}

.tags-scrollable-container::-webkit-scrollbar {
  width: 6px;
}

.tags-scrollable-container::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 3px;
}

.tags-scrollable-container::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 3px;
}

.tags-scrollable-container::-webkit-scrollbar-thumb:hover {
  background: #999;
}

/* Form labels styling */
.form-label {
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
  display: block;
}

/* Instructions box styling */
.bg-light {
  background-color: #f8f9fa !important;
}

/* Tags list scrollable styling */
.tags-list-scrollable {
  height: 100%;
  padding: 8px 12px;
}

.tags-list-scrollable .ant-list-item {
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.tags-list-scrollable .ant-list-item:hover {
  background-color: #f0f2f5;
  transform: translateX(2px);
}

.tags-list-scrollable .ant-list-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

/* Clickable tag styling */
.clickable-tag {
  position: relative;
}

.clickable-tag::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background-color: #1890ff;
  border-radius: 2px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.clickable-tag:hover::before {
  opacity: 1;
}

.clickable-tag:hover .timestamp-tag {
  background-color: #1890ff !important;
  color: white !important;
  transform: scale(1.05);
  transition: all 0.2s ease;
}

.clickable-tag .timestamp-tag {
  transition: all 0.2s ease;
  font-weight: 600;
}

.clickable-tag:hover .tag-name {
  color: #1890ff !important;
  font-weight: 600;
  transition: all 0.2s ease;
}
</style>
